const nation = [{value: "01", name: "汉族"}, {value: "02", name: "蒙古族"}, {value: "03", name: "回族"},
    {value: "04", name: "藏族"}, {value: "05", name: "维吾尔族"}, {value: "06", name: "苗族"},
    {value: "07", name: "彝族"}, {value: "08", name: "壮族"}, {value: "09", name: "布依族"},
    {value: "10", name: "朝鲜族"}, {value: "11", name: "满族"}, {value: "12", name: "侗族"},
    {value: "13", name: "瑶族"}, {value: "14", name: "白族"}, {value: "15", name: "土家族"},
    {value: "16", name: "哈尼族"}, {value: "17", name: "哈萨克族"}, {value: "18", name: "傣族"},
    {value: "19", name: "黎族"}, {value: "20", name: "傈僳族"}, {value: "21", name: "佤族"},
    {value: "22", name: "畲族"}, {value: "23", name: "高山族"}, {value: "24", name: "拉祜族"},
    {value: "25", name: "水族"}, {value: "26", name: "东乡族"}, {value: "27", name: "纳西族"},
    {value: "28", name: "景颇族"}, {value: "29", name: "柯尔克孜族"}, {value: "30", name: "土族"},
    {value: "31", name: "达斡尔族"}, {value: "32", name: "仫佬族"}, {value: "33", name: "羌族"},
    {value: "34", name: "布朗族"}, {value: "35", name: "撒拉族"}, {value: "36", name: "毛难族"},
    {value: "37", name: "仡佬族"}, {value: "38", name: "锡伯族"}, {value: "39", name: "阿昌族"},
    {value: "40", name: "普米族"}, {value: "41", name: "塔吉克族"}, {value: "42", name: "怒族"},
    {value: "43", name: "乌孜别克族"}, {value: "44", name: "俄罗斯族"}, {value: "45", name: "鄂温克族"},
    {value: "46", name: "崩龙族"}, {value: "47", name: "保安族"}, {value: "48", name: "裕固族"},
    {value: "49", name: "京族"}, {value: "50", name: "塔塔尔族"}, {value: "51", name: "独龙族"},
    {value: "52", name: "鄂伦春族"}, {value: "53", name: "赫哲族"}, {value: "54", name: "门巴族"},
    {value: "55", name: "珞巴族"}, {value: "56", name: "基诺族"}]


const userdata = JSON.parse(window.localStorage.getItem('userdata'));
// DDisplay_subject            陈列-课程方向      id  7
// DDisplay_professional       陈列-专业方向      id  7
// training                    培训类型
// Technology_subject          技术-课程方向      id  6
// Technology_professional     技术-专业方向      id  6
// designer                    设计师类别
// education                   学历
const DDisplay_subject = JSON.parse(window.localStorage.getItem('dictdata')).DDisplay_subject;
const DDisplay_professional = JSON.parse(window.localStorage.getItem('dictdata')).DDisplay_professional;
const training = JSON.parse(window.localStorage.getItem('dictdata')).training;
const Technology_subject = JSON.parse(window.localStorage.getItem('dictdata')).Technology_subject;
const Technology_professional = JSON.parse(window.localStorage.getItem('dictdata')).Technology_professional;
const designer = JSON.parse(window.localStorage.getItem('dictdata')).designer;
const education = JSON.parse(window.localStorage.getItem('dictdata')).education;
// 个人
const personal = {
    //时装艺术专业委员会 Fashion zhao 2024年11月8日17:34:25
    Fashion: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "姓名",
                    prop: "full_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: [
                        {value: 1, name: '是',},
                        {value: 0, name: '否',}
                    ]
                },
                {
                    label: "性別",
                    prop: "gender",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: '男', name: '男',},
                        {value: '女', name: '女',}
                    ]
                },
                {
                    label: "民族",
                    prop: "nationality",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: nation
                },
            ],
            [
                {
                    label: "手机号",
                    prop: "mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微信号",
                    prop: "wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "邮箱",
                    prop: "email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "证件类型/证件号",
                    select_prop: "card_type",
                    prop: "IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'select_input',
                    type: 'text',
                    options: []
                },
                // {
                //     label: "身份证号",
                //     prop: "IDCard",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input',
                //     type: 'text',
                //     options: []
                // },
                {
                    label: "工作单位",
                    prop: "company",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "职务",
                    prop: "position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历",
                    prop: "education_level",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: education
                },
                {
                    label: "最高学历院校",
                    prop: "graduate_school",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "最高学历专业",
                    prop: "majors",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "职称",
                    prop: "job_title",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "免冠照",
                    prop: "head_photo",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件正面",
                    prop: "IDCard_facade_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件反面",
                    prop: "IDCard_back_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历证明",
                    prop: "diploma",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "职称证明文件",
                    prop: "job_title_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "任职证明文件",
                    prop: "position_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '任职证明需加盖单位公章，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],
            {
                title: '个人简历',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "教育经历",
                    prop: "educational_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、院校、专业',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "培训经历",
                    prop: "training_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、培训课程',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "工作经历",
                    prop: "work_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、单位、职务',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖经历及专业成就（研究成果、工作业绩）",
                    prop: "personal_achievements",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '获奖经历及专业成就',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国内参展或活动情况",
                    prop: "domestic_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国外参展或活动情况",
                    prop: "foreign_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖证书及成就证明文件",
                    prop: "personal_achievements_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '包含获奖证书、专业成就证明文件，请整理成一个文件上传，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "个人作品",
                    prop: "personal_works",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含手绘稿，效果图，成衣图，请将文件整理成一个文件上传，pdf文件或图片均可，大小在5M以内',
                    options: []
                },
                {
                    label: "活动相关证明资料",
                    prop: "activity_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含活动现场图，相关报道等资料，请将资料整理成一个文件上传，paf或图片均可，大小在5M以内',
                    options: []
                },
            ],
            {
                title: '自媒体账号',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "微博账号",
                    prop: "weibo_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微博粉丝数",
                    prop: "weibo",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "抖音账号",
                    prop: "tiktok_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "抖音粉丝数",
                    prop: "tiktok",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "小红书账号",
                    prop: "red_book_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "小红书粉丝数",
                    prop: "red_book",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "其他平台",
                    prop: "other_platforms_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "其他平台粉丝数",
                    prop: "other_platforms",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {},
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "已参加的组织",
                    prop: "organization",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '已参加的组织名称及职务',
                    type: 'textarea',
                    options: []
                },
                {},
                {}
            ],
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {},
                // {
                //     label: "是否自有工作室/品牌",
                //     prop: "is_brand",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'el_option',
                //     multiple: false,
                //     type: 'text',
                //     options: [
                //         {value: 1, name: '是',},
                //         {value: 0, name: '否',}
                //     ]
                // },
                {},
            ],
            {
                title: '设计师类别',
                prop: "company_",
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "设计师类别",
                    prop: "designers_type",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: designer
                },

            ],
            {
                title: '公司信息',
                class: 'Divider',
                display: true,
            },
            [
                // {
                //     label: "公司信息",
                //     prop: "comapny_info",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input_textarea',
                //     type: 'textarea',
                //     options: []
                // },

                {
                    label: "公司规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "operating_condition",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            {
                title: '品牌',
                class: 'Divider',
                display: true,
            },
        ],
    },


    // 海归设计师俱乐部 Returnee id==11  2025年12月24日11:28:56
    Returnee: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "姓名",
                    prop: "full_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: [
                        {value: 1, name: '是',},
                        {value: 0, name: '否',}
                    ]
                },
                {
                    label: "性別",
                    prop: "gender",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: '男', name: '男',},
                        {value: '女', name: '女',}
                    ]
                },
                {
                    label: "民族",
                    prop: "nationality",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: nation
                },
            ],
            [
                {
                    label: "手机号",
                    prop: "mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微信号",
                    prop: "wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "邮箱",
                    prop: "email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "证件类型/证件号",
                    select_prop: "card_type",
                    prop: "IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'select_input',
                    type: 'text',
                    options: []
                },
                // {
                //     label: "身份证号",
                //     prop: "IDCard",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input',
                //     type: 'text',
                //     options: []
                // },
                {
                    label: "工作单位",
                    prop: "company",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "职务",
                    prop: "position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历",
                    prop: "education_level",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: education
                },
                {
                    label: "最高学历院校",
                    prop: "graduate_school",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "最高学历专业",
                    prop: "majors",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "职称",
                    prop: "job_title",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "免冠照",
                    prop: "head_photo",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件正面",
                    prop: "IDCard_facade_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件反面",
                    prop: "IDCard_back_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历证明",
                    prop: "diploma",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "职称证明文件",
                    prop: "job_title_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "任职证明文件",
                    prop: "position_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '任职证明需加盖单位公章，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],
            {
                title: '个人简历',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "教育经历",
                    prop: "educational_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、院校、专业',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "培训经历",
                    prop: "training_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、培训课程',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "工作经历",
                    prop: "work_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、单位、职务',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖经历及专业成就（研究成果、工作业绩）",
                    prop: "personal_achievements",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '获奖经历及专业成就',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国内参展或活动情况",
                    prop: "domestic_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国外参展或活动情况",
                    prop: "foreign_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖证书及成就证明文件",
                    prop: "personal_achievements_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '包含获奖证书、专业成就证明文件，请整理成一个文件上传，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "个人作品",
                    prop: "personal_works",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含手绘稿，效果图，成衣图，请将文件整理成一个文件上传，pdf文件或图片均可，大小在5M以内',
                    options: []
                },
                {
                    label: "活动相关证明资料",
                    prop: "activity_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含活动现场图，相关报道等资料，请将资料整理成一个文件上传，paf或图片均可，大小在5M以内',
                    options: []
                },
            ],
            {
                title: '自媒体账号',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "微博账号",
                    prop: "weibo_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微博粉丝数",
                    prop: "weibo",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "抖音账号",
                    prop: "tiktok_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "抖音粉丝数",
                    prop: "tiktok",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "小红书账号",
                    prop: "red_book_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "小红书粉丝数",
                    prop: "red_book",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "其他平台",
                    prop: "other_platforms_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "其他平台粉丝数",
                    prop: "other_platforms",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {},
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "已参加的组织",
                    prop: "organization",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '已参加的组织名称及职务',
                    type: 'textarea',
                    options: []
                },
                {},
                {}
            ],
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {},
                // {
                //     label: "是否自有工作室/品牌",
                //     prop: "is_brand",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'el_option',
                //     multiple: false,
                //     type: 'text',
                //     options: [
                //         {value: 1, name: '是',},
                //         {value: 0, name: '否',}
                //     ]
                // },
                {},
            ],
            {
                title: '设计师类别',
                prop: "company_",
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "设计师类别",
                    prop: "designers_type",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: designer
                },

            ],
            {
                title: '公司信息',
                class: 'Divider',
                display: true,
            },
            [
                // {
                //     label: "公司信息",
                //     prop: "comapny_info",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input_textarea',
                //     type: 'textarea',
                //     options: []
                // },

                {
                    label: "公司规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "operating_condition",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            {
                title: '品牌',
                class: 'Divider',
                display: true,
            },
        ],
    },


    //配饰艺术专业委员会 Accessory 赵 2024年11月12日15:07:31
    Accessory: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "姓名",
                    prop: "full_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: [
                        {value: 1, label: '是',},
                        {value: 0, label: '否',}
                    ]
                },
                {
                    label: "性別",
                    prop: "gender",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: '男', name: '男',},
                        {value: '女', name: '女',}
                    ]
                },
                {
                    label: "民族",
                    prop: "nationality",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: nation
                },
            ],
            [
                {
                    label: "手机号",
                    prop: "mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微信号",
                    prop: "wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "邮箱",
                    prop: "email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "证件类型/证件号",
                    select_prop: "card_type",
                    prop: "IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'select_input',
                    type: 'text',
                    options: []
                },
                // {
                //     label: "身份证号",
                //     prop: "IDCard",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input',
                //     type: 'text',
                //     options: []
                // },
                {
                    label: "工作单位",
                    prop: "company",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "职务",
                    prop: "position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历",
                    prop: "education_level",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: education
                },
                {
                    label: "最高学历院校",
                    prop: "graduate_school",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "最高学历专业",
                    prop: "majors",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "职称",
                    prop: "job_title",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "免冠照",
                    prop: "head_photo",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '',
                    options: []
                },
                {
                    label: "身份证/证件正面",
                    prop: "IDCard_facade_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件反面",
                    prop: "IDCard_back_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历证明",
                    prop: "diploma",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "职称证明文件",
                    prop: "job_title_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "任职证明文件",
                    prop: "position_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '任职证明需加盖单位公章，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],

            {
                title: '个人简历',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "教育经历",
                    prop: "educational_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、院校、专业',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "培训经历",
                    prop: "training_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、培训课程',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "工作经历",
                    prop: "work_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、单位、职务',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖经历及专业成就（研究成果、工作业绩）",
                    prop: "personal_achievements",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '获奖经历及专业成就',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国内参展或活动情况",
                    prop: "domestic_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国外参展或活动情况",
                    prop: "foreign_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖证书及成就证明文件",
                    prop: "personal_achievements_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '包含获奖证书、专业成就证明文件，请整理成一个文件上传，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "个人作品",
                    prop: "personal_works",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含手绘稿，效果图，成衣图，请将文件整理成一个文件上传，pdf文件或图片均可，大小在5M以内',
                    options: []
                },
                {
                    label: "活动相关证明资料",
                    prop: "activity_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含活动现场图，相关报道等资料，请将资料整理成一个文件上传，paf或图片均可，大小在5M以内',
                    options: []
                },
            ],
            {
                title: '自媒体账号',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "微博账号",
                    prop: "weibo_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微博粉丝数",
                    prop: "weibo",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "抖音账号",
                    prop: "tiktok_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "抖音粉丝数",
                    prop: "tiktok",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "小红书账号",
                    prop: "red_book_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "小红书粉丝数",
                    prop: "red_book",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "其他平台",
                    prop: "other_platforms_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "其他平台粉丝数",
                    prop: "other_platforms",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {},
            ],

            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "已参加的组织",
                    prop: "organization",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '已参加的组织名称及职务',
                    type: 'textarea',
                    options: []
                },
                {},
                {},
            ],
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {},
                {},
            ],
            {
                title: '设计师类别',
                prop: "company_",
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "设计师类别",
                    prop: "designers_type",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: designer
                },

            ],
            {
                title: '公司信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "公司规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "operating_condition",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            {
                title: '品牌',
                class: 'Divider',
                display: true,
            },

        ],
    },


    //学术工作委员会 Academic 赵 2024年11月12日15:13:25
    Academic: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "姓名",
                    prop: "full_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: [
                        {value: 1, label: '是',},
                        {value: 0, label: '否',}
                    ]
                },
                {
                    label: "性別",
                    prop: "gender",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: '男', name: '男',},
                        {value: '女', name: '女',}
                    ]
                },
                {
                    label: "民族",
                    prop: "nationality",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: nation
                },
            ],
            [
                {
                    label: "手机号",
                    prop: "mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微信号",
                    prop: "wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "邮箱",
                    prop: "email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "证件类型/证件号",
                    select_prop: "card_type",
                    prop: "IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'select_input',
                    type: 'text',
                    options: []
                },
                // {
                //     label: "身份证号",
                //     prop: "IDCard",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input',
                //     type: 'text',
                //     options: []
                // },
                {
                    label: "工作单位",
                    prop: "company",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "职务",
                    prop: "position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历",
                    prop: "education_level",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: education
                },
                {
                    label: "最高学历院校",
                    prop: "graduate_school",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "最高学历专业",
                    prop: "majors",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "职称",
                    prop: "job_title",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [

                {
                    label: "免冠照",
                    prop: "head_photo",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件正面",
                    prop: "IDCard_facade_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件反面",
                    prop: "IDCard_back_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历证明",
                    prop: "diploma",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "职称证明文件",
                    prop: "job_title_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "任职证明文件",
                    prop: "position_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '任职证明需加盖单位公章，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],
            {
                title: '个人简历',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "教育经历",
                    prop: "educational_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、院校、专业',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "培训经历",
                    prop: "training_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、培训课程',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "工作经历",
                    prop: "work_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、单位、职务',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖经历及专业成就（研究成果、工作业绩）",
                    prop: "personal_achievements",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '获奖经历及专业成就',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国内参展或活动情况",
                    prop: "domestic_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "国外参展或活动情况",
                    prop: "foreign_activities",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '请输入活动日期、活动名称',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖证书及成就证明文件",
                    prop: "personal_achievements_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '包含获奖证书、专业成就证明文件，请整理成一个文件上传，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                // {
                //     label: "个人作品",
                //     prop: "personal_works",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'image_up',
                //     type: 'image',
                //     prompt: '可包含手绘稿，效果图，成衣图，请将文件整理成一个文件上传，pdf文件或图片均可，大小在5M以内',
                //     options: []
                // },
                {
                    label: "活动相关证明资料",
                    prop: "activity_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含活动现场图，相关报道等资料，请将资料整理成一个文件上传，paf或图片均可，大小在5M以内',
                    options: []
                },
                {}
            ],
            {
                title: '自媒体账号',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "微博账号",
                    prop: "weibo_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微博粉丝数",
                    prop: "weibo",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "抖音账号",
                    prop: "tiktok_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "抖音粉丝数",
                    prop: "tiktok",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "小红书账号",
                    prop: "red_book_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "小红书粉丝数",
                    prop: "red_book",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "其他平台",
                    prop: "other_platforms_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "其他平台粉丝数",
                    prop: "other_platforms",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {},
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "是否自有工作室/品牌",
                    prop: "is_brand",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: 1, name: '是',},
                        {value: 0, name: '否',}
                    ]
                },
                {},
            ],
            [
                {
                    label: "已参加的组织",
                    prop: "organization",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '已参加的组织名称及职务',
                    type: 'textarea',
                    options: []
                },
                {},
                {},
            ],
            {
                title: '公司信息',
                prop: "company_",
                class: 'Divider',
                display: true,
            },
            [

                {
                    label: "公司规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "operating_condition",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            {
                title: '设计师类别',
                prop: "company_",
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "设计师类别",
                    prop: "designers_type",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: designer
                },

            ],
            {
                title: '品牌',
                prop: "brand",
                class: 'Divider',
                display: true,
            },
        ],
    },


    //技术工作委员会 Technology 赵 2024年11月12日15:13:25
    Technology: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "姓名",
                    prop: "full_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: [
                        {value: 1, label: '是',},
                        {value: 0, label: '否',}
                    ]
                },
                {
                    label: "性別",
                    prop: "gender",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: '男', name: '男',},
                        {value: '女', name: '女',}
                    ]
                },
                {
                    label: "民族",
                    prop: "nationality",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: nation
                },
            ],
            [
                {
                    label: "手机号",
                    prop: "mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微信号",
                    prop: "wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "邮箱",
                    prop: "email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "证件类型/证件号",
                    select_prop: "card_type",
                    prop: "IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'select_input',
                    type: 'text',
                    options: []
                },
                // {
                //     label: "身份证号",
                //     prop: "IDCard",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input',
                //     type: 'text',
                //     options: []
                // },
                {
                    label: "工作单位",
                    prop: "company",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "职务",
                    prop: "position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历",
                    prop: "education_level",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: education
                },
                {
                    label: "最高学历院校",
                    prop: "graduate_school",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "最高学历专业",
                    prop: "majors",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "职称",
                    prop: "job_title",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "免冠照",
                    prop: "head_photo",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件正面",
                    prop: "IDCard_facade_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件反面",
                    prop: "IDCard_back_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历证明",
                    prop: "diploma",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "职称证明文件",
                    prop: "job_title_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "任职证明文件",
                    prop: "position_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '任职证明需加盖单位公章，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],

            {
                title: '个人简历',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "教育经历",
                    prop: "educational_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、院校、专业',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "培训经历",
                    prop: "training_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、培训课程',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "工作经历",
                    prop: "work_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、单位、职务',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖经历及专业成就（研究成果、工作业绩）",
                    prop: "personal_achievements",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '获奖经历及专业成就',
                    type: 'textarea',
                    options: []
                },
                {},
                {}
            ],
            [
                {
                    label: "获奖证书及成就证明文件",
                    prop: "personal_achievements_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '包含获奖证书、专业成就证明文件，请整理成一个文件上传，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "个人作品",
                    prop: "personal_works",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含手绘稿，效果图，成衣图，请将文件整理成一个文件上传，pdf文件或图片均可，大小在5M以内',
                    options: []
                },
                {},

            ],
            {
                title: '自媒体账号',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "微博账号",
                    prop: "weibo_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微博粉丝数",
                    prop: "weibo",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "抖音账号",
                    prop: "tiktok_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "抖音粉丝数",
                    prop: "tiktok",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "小红书账号",
                    prop: "red_book_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "小红书粉丝数",
                    prop: "red_book",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "其他平台",
                    prop: "other_platforms_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "其他平台粉丝数",
                    prop: "other_platforms",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {},
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {},
                {}
            ],
            [
                {
                    label: "专业方向",
                    prop: "major_field",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: userdata.committee_id == 7 ? DDisplay_professional : Technology_professional
                },
            ],
            [
                {
                    label: "希望学习的课程方向",
                    prop: "course_direction",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: userdata.committee_id == 7 ? DDisplay_subject : Technology_subject
                },
            ],
            [
                {
                    label: "已参加的组织",
                    prop: "organization",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '已参加的组织名称及职务',
                    type: 'textarea',
                    options: []
                },

                {},
                {},
            ],
            {
                title: '公司信息',
                prop: "company_",
                class: 'Divider',
                display: true,
            },
            [

                {
                    label: "公司规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "operating_condition",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "是否为个人工作室",
                    prop: "is_studio",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: 1, name: '是',},
                        {value: 0, name: '否',}
                    ]
                },

            ],
        ],

    },


    //陈列设计专业委员会 DDisplay 赵 2024年11月12日15:13:25
    DDisplay: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "姓名",
                    prop: "full_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: [
                        {value: 1, label: '是',},
                        {value: 0, label: '否',}
                    ]
                },
                {
                    label: "性別",
                    prop: "gender",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: '男', name: '男',},
                        {value: '女', name: '女',}
                    ]
                },
                {
                    label: "民族",
                    prop: "nationality",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: nation
                },
            ],
            [
                {
                    label: "手机号",
                    prop: "mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微信号",
                    prop: "wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "邮箱",
                    prop: "email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "证件类型/证件号",
                    select_prop: "card_type",
                    prop: "IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'select_input',
                    type: 'text',
                    options: []
                },
                // {
                //     label: "身份证号",
                //     prop: "IDCard",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input',
                //     type: 'text',
                //     options: []
                // },
                {
                    label: "工作单位",
                    prop: "company",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "职务",
                    prop: "position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历",
                    prop: "education_level",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: education
                },
                {
                    label: "最高学历院校",
                    prop: "graduate_school",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "最高学历专业",
                    prop: "majors",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "职称",
                    prop: "job_title",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "免冠照",
                    prop: "head_photo",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件正面",
                    prop: "IDCard_facade_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
                {
                    label: "身份证/证件反面",
                    prop: "IDCard_back_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '上传图片，大小在2M以内',
                    options: []
                },
            ],
            [
                {
                    label: "最高学历证明",
                    prop: "diploma",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "职称证明文件",
                    prop: "job_title_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "任职证明文件",
                    prop: "position_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '任职证明需加盖单位公章，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],

            {
                title: '个人简历',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "教育经历",
                    prop: "educational_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、院校、专业',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "培训经历",
                    prop: "training_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、培训课程',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "工作经历",
                    prop: "work_experience",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '年月、单位、职务',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "获奖经历及专业成就（研究成果、工作业绩）",
                    prop: "personal_achievements",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '获奖经历及专业成就',
                    type: 'textarea',
                    options: []
                },
                {},
                {}
            ],
            [
                {
                    label: "获奖证书及成就证明文件",
                    prop: "personal_achievements_pic",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '包含获奖证书、专业成就证明文件，请整理成一个文件上传，pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "个人作品",
                    prop: "personal_works",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '可包含手绘稿，效果图，成衣图，请将文件整理成一个文件上传，pdf文件或图片均可，大小在5M以内',
                    options: []
                },
                {},
            ],
            {
                title: '自媒体账号',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "微博账号",
                    prop: "weibo_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "微博粉丝数",
                    prop: "weibo",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "抖音账号",
                    prop: "tiktok_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "抖音粉丝数",
                    prop: "tiktok",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "小红书账号",
                    prop: "red_book_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "小红书粉丝数",
                    prop: "red_book",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "其他平台",
                    prop: "other_platforms_account",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "其他平台粉丝数",
                    prop: "other_platforms",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {},
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },

                {},
                {}
            ],
            [
                {
                    label: "专业方向",
                    prop: "major_field",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: userdata.committee_id == 7 ? DDisplay_professional : Technology_professional
                },
            ],
            [
                {
                    label: "希望学习的课程方向",
                    prop: "course_direction",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: userdata.committee_id == 7 ? DDisplay_subject : Technology_subject
                },
            ],
            [
                {
                    label: "已参加的组织",
                    prop: "organization",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '已参加的组织名称及职务',
                    type: 'textarea',
                    options: []
                },

                {},
                {},
            ],
            {
                title: '公司信息',
                prop: "company_",
                class: 'Divider',
                display: true,
            },
            [

                {
                    label: "公司规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "operating_condition",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "是否为个人工作室",
                    prop: "is_studio",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: 1, name: '是',},
                        {value: 0, name: '否',}
                    ]
                },
            ],

        ],

    },
}

// 企业
const enterprise = {

    // 单位会员 服装上下游企业 Company_clothing 赵
    Company_clothing: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "performance",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "是否为规上企业",
                    prop: "is_rules",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: 1, name: '是',},
                        {value: 0, name: '否',}
                    ]
                },
            ],
            [
                {
                    label: "企业处于纺织服装及时尚产业的哪个环节",
                    prop: "that_stage",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '企业处于纺织服装及时尚产业的哪个环节',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "企业主营业务介绍",
                    prop: "business_introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '企业主营业务介绍',
                    type: 'textarea',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "入会后希望获得哪方面的支持和权益",
                    prop: "company_wish",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '入会后希望获得哪方面的支持和权益',
                    type: 'textarea',
                    options: []
                },
                {},
            ],
            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {},
                {},
            ],
            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            {
                title: '品牌',
                prop: "brand",
                class: 'Divider',
                display: true,
            },
        ],

    },

    // 单位会员 园区 Company_park 赵
    Company_park: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                // {
                //     label: "协会会员数量",
                //     prop: "settled_count",
                //     disabled: false,
                //     display: true,
                //     assembly_type: 'input',
                //     type: 'number',
                //     options: []
                // },
                {
                    label: "入驻企业数量",
                    prop: "settled_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "入会后希望获得哪方面的支持和权益",
                    prop: "company_wish",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '入会后希望获得哪方面的支持和权益',
                    type: 'textarea',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {},
                {}
            ],
            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

        ],
    },

    // 单位会员 商协会 Company_business 赵
    Company_business: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {
                    label: "协会会员数量",
                    prop: "vip_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "单位开展主要活动",
                    prop: "main_activity",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位开展主要活动',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "入会后希望获得哪方面的支持和权益",
                    prop: "company_wish",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '入会后希望获得哪方面的支持和权益',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {},
                {},
            ],
            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

        ],
    },

    // 单位会员 院校 Company_colleges 赵
    Company_colleges: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "服装、配饰、时尚相关专业一级学科数量",
                    prop: "first_discipline",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "服装、配饰、时尚相关专业二级学科数量",
                    prop: "secondary_discipline",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },


            ],
            [
                {
                    label: "服装、配饰、时尚相关专业在校生人数",
                    prop: "students_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "服装、配饰、时尚相关专业教职工人数",
                    prop: "teachers_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "入会后希望获得哪方面的支持和权益",
                    prop: "company_wish",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '入会后希望获得哪方面的支持和权益',
                    type: 'textarea',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {},
                {},

            ],
            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],

            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

        ],

    },

    // 职业时装模特工作委员会 公司 FModel_company 赵
    FModel_company: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],

            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "签约模特人数",
                    prop: "models_signed_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "代理模特人数",
                    prop: "models_proxy_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
            ],
            [
                {
                    label: "专业成就",
                    prop: "professional_achievement",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '专业成就',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "曾主办、承办及参与的行业大型项目",
                    prop: "large_projects",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '曾主办、承办及参与的行业大型项目',
                    type: 'textarea',
                    options: []
                },

                {
                    label: "对模特行业现状的看法和建议",
                    prop: "suggestion",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '对模特行业现状的看法和建议',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "办公经营场所照片若干张",
                    prop: "business_photos",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
            ],

            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

        ],

    },

    // 职业时装模特工作委员会 培训机构 FModel_train 赵
    FModel_train: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],

            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {},
                {}
            ],
            [
                {
                    label: "培训类型",
                    prop: "training_type",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_checkbox',
                    xl: 24,
                    lg: 24,
                    options: training
                },
            ],
            [

                {
                    label: "累积毕业人数",
                    prop: "graduates_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "在读人数",
                    prop: "readers_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {}

            ],
            [
                {
                    label: "学生平均年龄",
                    prop: "average_age",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

                {
                    label: "男学生平均身高（cm）",
                    prop: "average_height",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "女学生平均身高（cm）",
                    prop: "average_height_girl",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },

            ],
            [
                {
                    label: "机构简介",
                    prop: "institution_introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '机构简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "专业成就",
                    prop: "professional_achievement",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '专业成就',
                    type: 'textarea',
                    options: []
                },

            ],
            [
                {
                    label: "本年度升学情况",
                    prop: "enrollment_status",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '本年度升学情况',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "本年度就业情况",
                    prop: "employment_situation",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '本年度就业情况',
                    type: 'textarea',
                    options: []
                },
                {}
            ],
            [
                {
                    label: "入会后希望获得哪方面的支持和权益",
                    prop: "company_wish",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '入会后希望获得哪方面的支持和权益',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "曾主办、承办及参与的行业大型项目",
                    prop: "large_projects",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '曾主办、承办及参与的行业大型项目',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "对模特行业现状的看法和建议",
                    prop: "suggestion",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '对模特行业现状的看法和建议',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "办公经营场所照片若干张",
                    prop: "business_photos",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '',
                    options: []
                },
                {
                    label: "机构宣传印刷品",
                    prop: "printed_materials",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],

            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

        ],
    },

    // 职业时装模特工作委员会 其他相关公司 FModel_other 赵
    FModel_other: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],

            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {},
                {}
            ],
            [
                {
                    label: "专业成就",
                    prop: "professional_achievement",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '专业成就',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },

                {
                    label: "曾主办、承办及参与的行业大型项目",
                    prop: "large_projects",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '曾主办、承办及参与的行业大型项目',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "对模特行业现状的看法和建议",
                    prop: "suggestion",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '对模特行业现状的看法和建议',
                    type: 'textarea',
                    options: []
                },

                {},
                {}
            ],
            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "办公经营场所照片若干张",
                    prop: "business_photos",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: '',
                    options: []
                },
                {
                    label: "机构宣传印刷品",
                    prop: "printed_materials",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
                {}
            ],

            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

        ],
    },

    // 职业时装模特工作委员会 院校 FModel_colleges 赵
    FModel_colleges: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "专业名称",
                    prop: "major_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "累积毕业人数",
                    prop: "graduates_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
            ],
            [

                {
                    label: "学生平均年龄",
                    prop: "average_age",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "男学生平均身高（cm）",
                    prop: "average_height",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "女学生平均身高（cm）",
                    prop: "average_height_girl",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
            ],
            [
                {
                    label: "在读人数",
                    prop: "readers_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {},
                {}
            ],
            [{
                label: "本年度就业情况",
                prop: "employment_situation",
                disabled: false,
                display: true,
                assembly_type: 'input_textarea',
                prompt: '本年度就业情况',
                type: 'textarea',
                options: []
            },
                {
                    label: "专业简介",
                    prop: "major_introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '专业简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
            ],
            [
                {
                    label: "曾主办、承办及参与的行业大型项目",
                    prop: "large_projects",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '曾主办、承办及参与的行业大型项目',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "专业成就",
                    prop: "professional_achievement",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '学术及所属模特省级以上奖项，不含省级',
                    type: 'textarea',
                    options: []
                },

                {
                    label: "对模特行业现状的看法和建议",
                    prop: "suggestion",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '对模特行业现状的看法和建议',
                    type: 'textarea',
                    options: []
                },
            ],

            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "教学场地照片",
                    prop: "teaching_photos",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {
                    label: "机构宣传印刷品",
                    prop: "printed_materials",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'pdf文件或图片均可，大小在2M以内',
                    options: []
                },
            ],

            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],

            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
        ],
    },

    //品牌工作委员会 品牌工作委员会 Brand_brand zhao 2024年11月13日18:08:57
    Brand_brand: {
        basic: [
            {
                title: '基本信息',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "单位名称",
                    prop: "company_name",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "成立时间",
                    prop: "established_time",
                    disabled: false,
                    display: true,
                    assembly_type: 'date',
                    type: 'date',
                    options: []
                },
                {
                    label: "单位网址",
                    prop: "company_website",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],

            [
                {
                    label: "单位规模（员工人数）",
                    prop: "company_size",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "经营状况（年度营收金额，单位:万元）",
                    prop: "performance",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {
                    label: "是否为规上企业",
                    prop: "is_rules",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    multiple: false,
                    type: 'text',
                    options: [
                        {value: 1, name: '是',},
                        {value: 0, name: '否',}
                    ]
                },


            ],
            [

                {
                    label: "集团下品牌数量",
                    prop: "brands_count",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'number',
                    options: []
                },
                {},
                {}
            ],
            [
                {
                    label: "单位简介",
                    prop: "company_Introduction",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '单位简介',
                    type: 'textarea',
                    options: []
                },
                {
                    label: "入会后希望获得哪方面的支持和权益",
                    prop: "company_wish",
                    disabled: false,
                    display: true,
                    assembly_type: 'input_textarea',
                    prompt: '入会后希望获得哪方面的支持和权益',
                    type: 'textarea',
                    options: []
                },
                {}
            ],

            [
                {
                    label: "营业执照（法人证书）",
                    prop: "business_license",
                    disabled: false,
                    display: true,
                    assembly_type: 'image_up',
                    type: 'image',
                    prompt: 'PDF文件或图片均可，大小在2M以内',
                    options: []
                },
                {},
                {},
            ],
            {
                title: '单位联系人',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "会员代表姓名（一般为会长/董事长/院长）",
                    prop: "representative",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表职务",
                    prop: "representative_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表身份证号",
                    prop: "representative_IDCard",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },

            ],
            [
                {
                    label: "会员代表联系电话",
                    prop: "representative_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表微信号",
                    prop: "represent_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "会员代表邮箱",
                    prop: "represent_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人姓名",
                    prop: "contacts",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人职务",
                    prop: "contacts_position",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人电话",
                    prop: "contacts_mobile",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],
            [
                {
                    label: "联系人微信号",
                    prop: "contacts_wechat",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {
                    label: "联系人邮箱",
                    prop: "contacts_email",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
                {}
            ],
            {
                title: '其他',
                class: 'Divider',
                display: true,
            },
            [
                {
                    label: "杂志接收方式",
                    prop: "magazine_reception",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_option',
                    type: 'text',
                    options: [
                        {value: '邮寄纸质版(邮寄地址默认为通信地址)', name: '邮寄纸质版(邮寄地址默认为通信地址)',},
                        {value: '发送电子版', name: '发送电子版',}
                    ]
                },
                {
                    label: "省市地区",
                    prop: "city",
                    disabled: false,
                    display: true,
                    assembly_type: 'el_cascader',
                    type: 'text',
                    options: JSON.parse(window.localStorage.getItem("locationdata"))
                },
                {
                    label: "通信地址",
                    prop: "address",
                    disabled: false,
                    display: true,
                    assembly_type: 'input',
                    type: 'text',
                    options: []
                },
            ],

            {
                title: '品牌',
                prop: "brand",
                class: 'Divider',
                display: true,
            },
        ],

    }

}


// 品牌
const ModelTemplate = {
    portrait: [
        {
            label: "照片/证件照",
            prop: "photo",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        },
    ],
    information: [
        {
            label: "姓名",
            prop: "name",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "性別",
            prop: "gender",
            disabled: false,
            display: true,
            assembly_type: 'el_option',
            multiple: false,
            type: 'text',
            options: [
                {value: '男', name: '男',},
                {value: '女', name: '女',}
            ]
        },
        {
            label: "注册号码",
            prop: "register_number",
            disabled: true,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "签约单位",
            prop: "sign_company",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "身高",
            prop: "height",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        }, {
            label: "体重",
            prop: "weight",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "鞋码",
            prop: "shoe_size",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "籍贯",
            prop: "native_place",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        }, {
            label: "身份证号码",
            prop: "ID_number",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "胸围",
            prop: "bust",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "腰围",
            prop: "waist",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "臀围",
            prop: "hipline",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "常驻工作地点",
            prop: "permanent_address",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "注册单位",
            prop: "registered_company",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },
        {
            label: "毕业院校",
            prop: "graduation_colleges",
            disabled: false,
            display: true,
            assembly_type: 'input',
            type: 'text',
            options: []
        },

    ],
    fileCollection: [
        {
            label: "委托书（模特签字-上传）",
            prop: "mandate_file",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        }, {
            label: "身份证复印件",
            prop: "ID_card_file",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        }, {
            label: "素颜面部特写",
            prop: "face_feature_pic",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        },
        {
            label: "泳装正面照",
            prop: "swimwear_facade_pic",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        }, {
            label: "泳装侧面照",
            prop: "swimwear_side_pic",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        }, {
            label: "泳装背面照",
            prop: "swimwear_back_pic",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        },
        {
            label: "面试视频（竖屏30秒以内，5M以内）",
            prop: "interview_video",
            disabled: false,
            display: true,
            assembly_type: 'video_up',
            type: 'image',
            prompt: '',
            options: []
        },
        {
            label: "演出视频（竖屏30秒以内，5M以内）",
            prop: "show_video",
            disabled: false,
            display: true,
            assembly_type: 'video_up',
            type: 'image',
            prompt: '',
            options: []
        },
        {
            label: "毕业证照片",
            prop: "diploma_pic",
            disabled: false,
            display: true,
            assembly_type: 'image_up',
            type: 'image',
            prompt: '',
            options: []
        },
    ],
}
export {
    personal,
    enterprise,
    ModelTemplate
}